import { useTranslation } from 'react-i18next';
import ContactCTA from 'components/ContactCTA';

function Contact() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="container">
        <h1 className="page-title">{t('contactPage.title')}</h1>
        <div className="page-body">
          <p>{t('contactPage.intro')}</p>
        </div>
      </div>
      <ContactCTA />
    </div>
  );
}

export default Contact;
